module.exports = __webpack_public_path__ + "static/media/web_goshare_step3.74f61f63.mp4";